export default "__VITE_ASSET__DUhVwGa___"